export default __webpack_public_path__ + "img/fQmVWXUY.4763f91e.svg";